import { buildPrompt } from '@/ai/utils/promptBuilder'
import { examples } from '@/ai/prompts/common/examples'
import { readModelNotes } from '@/ai/prompts/common/instructions'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createSystemMessage, createUserMessage } from '@/ai/utils/promptUtils'
import { buildWorkflowSpec, buildCardTypesMap } from '@/shared/utils/workflowSpec'

export const buildReadModelFromEntityPrompt = ({ workflow, entity, cardTypes }) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []

  const { name: entityName, fields } = entity

  const entityFields = fields.map(({ name, exampleData }) => ({ name, exampleData }))

  const cardTypesMap = buildCardTypesMap(cardTypes)

  promptSections.push({
    title: 'Request',
    content: `Generate a Read Model for the actor about to act on "${entityName}". In most of the cases the generated data fields should match with the data fields of the entity and include the id field of the entity. An attribute can be a primitive or a reference to a non-primitive type like an associated entity. An attribute or field name must be in camel case format (e.g., 'productName' instead of 'Product Name'). An attribute or field name must each be at most 30 characters long. Also determine the cardinality: use "one-to-one" if the query returns a single item (e.g., viewing details of a specific ${entityName}), or "one-to-many" if it returns a list of items (e.g., listing multiple ${entityName}s). Default to "one-to-many" if unclear.`
  })

  promptSections.push({
    title: 'Current Workflow Specification (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: buildWorkflowSpec(workflow, null, cardTypesMap) || '{}'
  })

  promptSections.push({
    title: 'Entity definition (data fields)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify(entityFields)
  })

  const readModelExample = {
    readModel: examples.readModelExampleCart,
    cardinality: 'one-to-one',
    readModelDescription: 'Returns the customer\'s current cart so they can review items before checkout.'
  }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('readModel', JSON.stringify(readModelExample))
  })

  promptSections.push({
    title: 'Note',
    contentType: 'bullet',
    content: [
      readModelNotes[0],
      readModelNotes[1],
      readModelNotes[5],
      readModelNotes[7],
      readModelNotes[8],
      readModelNotes[9],
      readModelNotes[10]
    ]
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
